import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let StudentController = {

    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/student/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    list: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/student/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/student/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/student/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    delete: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/student/delete/${id}`,
            method: 'GET'
        }, callback)
    },
    search: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/student/search`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },

    chuyenTruong: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/student/chuyentruong`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    chuyenLop: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/student/chuyenlop`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },

    listPhanlop: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/student/list-phanlop`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    phanLop: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/student/phanlop`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    listChuaPhanlop: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/student/list-chua-phanlop`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    dieuChinhKetChuyen: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/student/dieu-chinh-ketchuyen`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
}

export default StudentController
